export const footerMoreLinks = {
  'de-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://www.wingie.de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://www.wingie.de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },

        {
          href: 'https://www.wingie.de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://www.wingie.de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://www.wingie.de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://www.wingie.de/impressum/',
          title: 'Impressum ',
        },
        {
          href: 'https://www.wingie.de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'de-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://www.wingie.de/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://www.wingie.de/en/faq/',
          title: 'Frequently Asked Questions',
        },

        {
          href: 'https://www.wingie.de/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://www.wingie.de/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.de/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://www.wingie.de/en/impressum/',
          title: 'Tag ',
        },
        {
          href: 'https://www.wingie.de/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'de-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://www.wingie.de/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://www.wingie.de/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://www.wingie.de/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://www.wingie.de/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://www.wingie.de/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://www.wingie.de/es/impressum/',
          title: 'Etiqueta ',
        },
        {
          href: 'https://www.wingie.de/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'de-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://www.wingie.de/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://www.wingie.de/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://www.wingie.de/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://www.wingie.de/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://www.wingie.de/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://www.wingie.de/ru/impressum/',
          title: 'Ярлык ',
        },
        {
          href: 'https://www.wingie.de/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'de-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://www.wingie.de/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://www.wingie.de/ar/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://www.wingie.de/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://www.wingie.de/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://www.wingie.de/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://www.wingie.de/ar/impressum/',
          title: 'بطاقة شعار ',
        },
        {
          href: 'https://www.wingie.de/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'de-it': [
    {
      title: 'Di più',
      items: [
        { title: 'Contatto', href: 'https://www.wingie.de/it/contact/' },
        // { title: 'Domande frequenti', href: 'https://www.wingie.de/it/faq/' },

        { title: 'Chi siamo', href: 'https://www.wingie.de/it/about-us/' },
        { title: 'Privacy', href: 'https://www.wingie.de/it/privacy/' },
        { title: 'Termini e condizioni', href: 'https://www.wingie.de/it/terms-and-conditions/' },
        { title: 'Impressum', href: 'https://www.wingie.de/it/impressum/' },
        { title: 'I nostri premi', href: 'https://www.wingie.de/it/awards/' },
      ],
    },
  ],
  'de-fr': [
    {
      title: 'Plus',
      items: [
        { title: 'Contact', href: 'https://www.wingie.de/fr/contact/' },
        // { title: 'Questions fréquemment posées', href: 'https://www.wingie.de/fr/faq/' },

        { title: 'À propos de nous', href: 'https://www.wingie.de/fr/about-us/' },
        { title: 'Confidentialité', href: 'https://www.wingie.de/fr/privacy/' },
        { title: 'Termes et conditions', href: 'https://www.wingie.de/fr/terms-and-conditions/' },
        { title: 'Impressum', href: 'https://www.wingie.de/fr/impressum/' },
        { title: 'Nos prix', href: 'https://www.wingie.de/fr/awards/' },
      ],
    },
  ],
  'de-pt': [
    {
      title: 'Mais',
      items: [
        { title: 'Contato', href: 'https://www.wingie.de/pt/contact/' },
        // { title: 'Perguntas frequentes', href: 'https://www.wingie.de/pt/faq/' },

        { title: 'Sobre nós', href: 'https://www.wingie.de/pt/about-us/' },
        { title: 'Privacidade', href: 'https://www.wingie.de/pt/privacy/' },
        { title: 'Termos e condições', href: 'https://www.wingie.de/pt/terms-and-conditions/' },
        { title: 'Impressum', href: 'https://www.wingie.de/pt/impressum/' },
        { title: 'Nossos prêmios', href: 'https://www.wingie.de/pt/awards/' },
      ],
    },
  ],
  'de-ro': [
    {
      title: 'Mai multe',
      items: [
        { title: 'Contact', href: 'https://www.wingie.de/ro/contact/' },
        // { title: 'Întrebări frecvente', href: 'https://www.wingie.de/ro/faq/' },

        { title: 'Despre noi', href: 'https://www.wingie.de/ro/about-us/' },
        { title: 'Confidențialitate', href: 'https://www.wingie.de/ro/privacy/' },
        { title: 'Termeni și condiții', href: 'https://www.wingie.de/ro/terms-and-conditions/' },
        { title: 'Impressum', href: 'https://www.wingie.de/ro/impressum/' },
        { title: 'Premiile noastre', href: 'https://www.wingie.de/ro/awards/' },
      ],
    },
  ],
  'de-pl': [
    {
      title: 'Więcej',
      items: [
        { title: 'Kontakt', href: 'https://www.wingie.de/pl/contact/' },
        // { title: 'Często zadawane pytania', href: 'https://www.wingie.de/pl/faq/' },

        { title: 'O nas', href: 'https://www.wingie.de/pl/about-us/' },
        { title: 'Prywatność', href: 'https://www.wingie.de/pl/privacy/' },
        { title: 'Regulamin', href: 'https://www.wingie.de/pl/terms-and-conditions/' },
        { title: 'Impressum', href: 'https://www.wingie.de/pl/impressum/' },
        { title: 'Nasze nagrody', href: 'https://www.wingie.de/pl/awards/' },
      ],
    },
  ],
  'de-lt': [
    {
      title: 'Daugiau',
      items: [
        { title: 'Kontaktai', href: 'https://www.wingie.de/lt/contact/' },
        // { title: 'Dažniausiai užduodami klausimai', href: 'https://www.wingie.de/lt/faq/' },

        { title: 'Apie mus', href: 'https://www.wingie.de/lt/about-us/' },
        { title: 'Privatumas', href: 'https://www.wingie.de/lt/privacy/' },
        { title: 'Taisyklės ir sąlygos', href: 'https://www.wingie.de/lt/terms-and-conditions/' },
        { title: 'Impressum', href: 'https://www.wingie.de/lt/impressum/' },
        { title: 'Mūsų apdovanojimai', href: 'https://www.wingie.de/lt/awards/' },
      ],
    },
  ],
  'de-uz': [
    {
      title: "Ko'proq",
      items: [
        { title: 'Aloqa', href: 'https://www.wingie.de/uz/contact/' },
        // { title: "Tez-tez so'raladigan savollar", href: 'https://www.wingie.de/uz/faq/' },

        { title: 'Biz haqimizda', href: 'https://www.wingie.de/uz/about-us/' },
        { title: 'Maxfiylik', href: 'https://www.wingie.de/uz/privacy/' },
        { title: 'Shartlar va qoidalar', href: 'https://www.wingie.de/uz/terms-and-conditions/' },
        { title: 'Impressum', href: 'https://www.wingie.de/uz/impressum/' },
        { title: 'Bizning mukofotlarimiz', href: 'https://www.wingie.de/uz/awards/' },
      ],
    },
  ],
  'de-sr': [
    {
      title: 'Više',
      items: [
        { title: 'Kontakt', href: 'https://www.wingie.de/sr/contact/' },
        // { title: 'Često postavljana pitanja', href: 'https://www.wingie.de/sr/faq/' },

        { title: 'O nama', href: 'https://www.wingie.de/sr/about-us/' },
        { title: 'Privatnost', href: 'https://www.wingie.de/sr/privacy/' },
        { title: 'Uslovi korišćenja', href: 'https://www.wingie.de/sr/terms-and-conditions/' },
        { title: 'Impressum', href: 'https://www.wingie.de/sr/impressum/' },
        { title: 'Naše nagrade', href: 'https://www.wingie.de/sr/awards/' },
      ],
    },
  ],
  'de-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { title: 'Байланыш', href: 'https://www.wingie.de/ky/contact/' },
        // { title: 'Көп берилүүчү суроолор', href: 'https://www.wingie.de/ky/faq/' },

        { title: 'Біз жөнүндө', href: 'https://www.wingie.de/ky/about-us/' },
        { title: 'Жашыруундук', href: 'https://www.wingie.de/ky/privacy/' },
        { title: 'Шарттар жана эрежелер', href: 'https://www.wingie.de/ky/terms-and-conditions/' },
        { title: 'Impressum', href: 'https://www.wingie.de/ky/impressum/' },
        { title: 'Биздин сыйлыктар', href: 'https://www.wingie.de/ky/awards/' },
      ],
    },
  ],
  'de-tg': [
    {
      title: 'Бештар',
      items: [
        { title: 'Тамос', href: 'https://www.wingie.de/tg/contact/' },
        // { title: 'Саволҳои зиёд пурсидашаванда', href: 'https://www.wingie.de/tg/faq/' },

        { title: 'Дар бораи мо', href: 'https://www.wingie.de/tg/about-us/' },
        { title: 'Махфият', href: 'https://www.wingie.de/tg/privacy/' },
        { title: 'Шартҳо ва қоидаҳо', href: 'https://www.wingie.de/tg/terms-and-conditions/' },
        { title: 'Impressum', href: 'https://www.wingie.de/tg/impressum/' },
        { title: 'Мукофотҳои мо', href: 'https://www.wingie.de/tg/awards/' },
      ],
    },
  ],
  'de-kk': [
    {
      title: 'Көбірек',
      items: [
        { title: 'Байланыс', href: 'https://www.wingie.de/kk/contact/' },
        // { title: 'Жиі қойылатын сұрақтар', href: 'https://www.wingie.de/kk/faq/' },

        { title: 'Біз туралы', href: 'https://www.wingie.de/kk/about-us/' },
        { title: 'Құпиялық', href: 'https://www.wingie.de/kk/privacy/' },
        { title: 'Шарттар мен ережелер', href: 'https://www.wingie.de/kk/terms-and-conditions/' },
        { title: 'Impressum', href: 'https://www.wingie.de/kk/impressum/' },
        { title: 'Біздің марапаттарымыз', href: 'https://www.wingie.de/kk/awards/' },
      ],
    },
  ],
  'de-nl': [
    {
      title: 'Meer',
      items: [
        { title: 'Contact', href: 'https://www.wingie.de/nl/contact/' },
        // { title: 'Veelgestelde vragen', href: 'https://www.wingie.de/nl/faq/' },

        { title: 'Over ons', href: 'https://www.wingie.de/nl/about-us/' },
        { title: 'Privacy', href: 'https://www.wingie.de/nl/privacy/' },
        { title: 'Voorwaarden', href: 'https://www.wingie.de/nl/terms-and-conditions/' },
        { title: 'Impressum', href: 'https://www.wingie.de/nl/impressum/' },
        { title: 'Onze prijzen', href: 'https://www.wingie.de/nl/awards/' },
      ],
    },
  ],
  'de-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://www.wingie.de/ja/contact/' },
        { title: 'よくある質問', href: 'https://www.wingie.de/en/faq/' },
        { title: '会社概要', href: 'https://www.wingie.de/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://www.wingie.de/ja/privacy/' },
        { title: '利用規約', href: 'https://www.wingie.de/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://www.wingie.de/ja/awards/' },
      ],
    },
  ],
  'de-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://www.wingie.de/zh/contact/' },
        { title: '常见问题', href: 'https://www.wingie.de/en/faq/' },
        { title: '关于我们', href: 'https://www.wingie.de/zh/about-us/' },
        { title: '隐私政策', href: 'https://www.wingie.de/zh/privacy/' },
        { title: '条款和条件', href: 'https://www.wingie.de/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://www.wingie.de/zh/awards/' },
      ],
    },
  ],
  'de-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://www.wingie.de/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://www.wingie.de/en/faq/' },
        { title: '회사 소개', href: 'https://www.wingie.de/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://www.wingie.de/ko/privacy/' },
        { title: '이용약관', href: 'https://www.wingie.de/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://www.wingie.de/ko/awards/' },
      ],
    },
  ],
  'de-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://www.wingie.de/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://www.wingie.de/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://www.wingie.de/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://www.wingie.de/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://www.wingie.de/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://www.wingie.de/hi/awards/' },
      ],
    },
  ],
  'de-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://www.wingie.de/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://www.wingie.de/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://www.wingie.de/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://www.wingie.de/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://www.wingie.de/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://www.wingie.de/ta/awards/' },
      ],
    },
  ],
  'de-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://www.wingie.de/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://www.wingie.de/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://www.wingie.de/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://www.wingie.de/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://www.wingie.de/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://www.wingie.de/th/awards/' },
      ],
    },
  ],
  'de-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://www.wingie.de/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://www.wingie.de/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://www.wingie.de/ur/about-us/' },
        { title: 'رازداری', href: 'https://www.wingie.de/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://www.wingie.de/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://www.wingie.de/ur/awards/' },
      ],
    },
  ],
  'de-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://www.wingie.de/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://www.wingie.de/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://www.wingie.de/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://www.wingie.de/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://www.wingie.de/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://www.wingie.de/ka/awards/' },
      ],
    },
  ],
}
